const MOBILE_VIEWPORT_QUERY = "(max-width: 1023px)";
const MOBILE_USER_AGENT_REGEX =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export function isMobileDevice() {
  if (typeof window === "undefined") {
    return false;
  }

  const isMobileViewport = window.matchMedia
    ? window.matchMedia(MOBILE_VIEWPORT_QUERY).matches
    : window.innerWidth <= 1023;

  const userAgent =
    typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  const isMobileUserAgent = MOBILE_USER_AGENT_REGEX.test(userAgent);

  return isMobileViewport || isMobileUserAgent;
}

export default isMobileDevice;
